<script lang="ts">
    import { onMount } from "svelte";
    import { goto } from "$app/navigation";
    import { getAuthToken } from "$lib/stores/auth";
    import { isPageActive } from "$lib/utils/is-page-active";
    import { ProgressBar } from "@prgm/sveltekit-progress-bar";
    import Footer from "$lib/components/navigation/footer.svelte";
    import Navbar from "$lib/components/navigation/navbar.svelte";
    import SectionNews from "$lib/components/section/News/section-news.svelte";
    import SubscribeSectionCmu from "$lib/components/section/Subcribe/cathmeup/SubscribeSectionCMU.svelte";
    import NewsListPages from "$lib/components/section/News/catchmeup/NewsListPages.svelte";
    import NewsListPagesCMU from "$lib/components/section/News/common/NewsListPagesCMU.svelte";

    export let data: any;

    $: queryParams = data.queryParams;
    $: client = data.client;
    $: news = data.news;
    $: categories = data.categories;
    $: permissions = data.permissions;
    $: customPath = data.customPath;
    $: currentNamePage = isPageActive("news", client, permissions);
    $: primaryColor = String(data?.permissions?.data?.colors?.primary);

    onMount(async () => {
        let authToken = await getAuthToken();
        if (!authToken && data?.client?.force_user_to_login === 1) {
            goto("/login");
        }
    });
</script>

<svelte:head>
    <title>{currentNamePage} - {client?.name}</title>
    <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={`${client?.favicon === null ? "/favicon-32x32.png" : client?.favicon}`}
    />
    <link
        rel="icon"
        type="image/png"
        sizes="96x96"
        href={`${client?.favicon === null ? "/favicon-96x96.png" : client?.favicon}`}
    />
    <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={`${client?.favicon === null ? "/favicon-16x16.png" : client?.favicon}`}
    />
</svelte:head>

<Navbar data={client} dataPermission={permissions} {customPath} />
<ProgressBar color={primaryColor} class="text-[${primaryColor}]" zIndex={100} />

{#if client?.code === "catchmeup"}
    <NewsListPagesCMU
        {currentNamePage}
        {primaryColor}
        {news}
        {categories}
        {client}
    />
    <SubscribeSectionCmu {primaryColor} />
{:else}
    <NewsListPages
        {queryParams}
        {currentNamePage}
        {primaryColor}
        {news}
        {categories}
        {client}
    />
{/if}

<Footer data={client} />
